export default __webpack_public_path__ + "static/reeling-304331e651c3d8782eb9e35bf32eb02c.svg";